import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

export default function useFloatings(category) {
  const [inert, setInert] = Recoil.useRecoilState(AppStore.app.inert);
  const list = Recoil.useRecoilValue(AppStore.floatings.list(category));
  const hash = Recoil.useRecoilValue(AppStore.floatings.hash(category));
  const floatings = React.useMemo(() => {
    return list.map(name => hash[name]);
  }, [list, hash])

  React.useEffect(() => {
    const modals = floatings.filter(floating => floating.modal);
    setInert(() => !!modals.length);
  }, [floatings, setInert]);

  return {
    inert: inert ? '' : undefined,
    floatings,
  };
}
